// Typelizer digest a328620508f8edf6deffb76b215bd18d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/documents/:document_id/questions */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/questions', params, options),
    method: 'post',
  }),
}
